module.exports = __webpack_public_path__ + "static/media/1POLICY38.c36e95ff.jpg";